import eng from "./translations/eng.json";
import fra from "./translations/fra.json";

const translations = {
  eng: eng,
  fra: fra,
};

export default translations;
